import { fetchAdminBillingAccountOrganization } from './fetchAdminBillingAccountOrganization';
import type { QueryFunctionContext } from '@tanstack/react-query';
import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { TCall } from 'app/queries/types/TCall';
import type { billingKeys } from './billingKeys';

type TParams = QueryFunctionContext<ReturnType<typeof billingKeys.accountHeader>>;

export const createFetchAdminBillingAccountHeaderQueryFn =
  (call: TCall) =>
  async ({ queryKey: [{ baId }], signal }: TParams) => {
    const [account, organization] = await Promise.all([
      call(() => cancelOnSignal(AdminService.getBillingAccount({ baId }), signal)),
      fetchAdminBillingAccountOrganization(call, baId, signal),
    ]);
    return { name: account.name, organization };
  };
